import { useDispatch, useSelector } from 'react-redux';

import { getItemCount } from 'cart/common/helpers';
import { getCartTitle } from 'common/helpers/miscHelpers';
import { showSideCart } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const UserTools = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  const cartReducer = useSelector((state) => state.cart);
  const settings = useSelector((state) => state.setting.data);

  const { data: cart } = cartReducer;

  const itemCount = getItemCount(cart);

  const handleClick = () => {
    dispatch(showSideCart());
  };

  return (
    <button
      type="button"
      className="c7-link"
      aria-label={
        itemCount === 1
          ? t('general.accessibility.viewSideCartItem', {
              cartTitle: getCartTitle(settings, t),
              itemCount
            })
          : t('general.accessibility.viewSideCartItems', {
              cartTitle: getCartTitle(settings, t),
              itemCount
            })
      }
      onClick={handleClick}
    >
      <span className="c7-user-nav__cart__title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          aria-hidden="true"
          role="presentation"
          focusable="false"
          stroke="#000"
        >
          <g fill="none" fillRule="evenodd" transform="translate(0 1)">
            <path d="M15.1479377,4.5 C15.53984,4.5 15.8987066,4.65086487 16.1671121,4.89941672 C16.4355176,5.14796856 16.6134619,5.49420737 16.6435194,5.88495525 L16.6435194,5.88495525 L17.3358271,14.8849553 C17.3675959,15.2979487 17.2289584,15.684721 16.9791303,15.9761871 C16.7328759,16.2634839 16.3785892,16.4581816 15.9729809,16.4941177 L15.9729809,16.4941177 L2.15975459,16.5 C1.74554102,16.5 1.37054102,16.3321068 1.09909441,16.0606602 C0.831519676,15.7930854 0.664565259,15.4248904 0.659856877,15.0177007 L0.659856877,15.0177007 L1.35648055,5.88495525 C1.38653808,5.49420737 1.5644824,5.14796856 1.83288789,4.89941672 C2.10129338,4.65086487 2.46016005,4.5 2.85206228,4.5 L2.85206228,4.5 Z" />
            <path
              strokeLinecap="round"
              d="M5,6 C5,2 6.33333333,0 9,0 C11.6666667,0 13,2 13,6"
            />
          </g>
        </svg>
        <span>{getCartTitle(settings, t)}</span>
      </span>
      <span className="c7-user-nav__cart__count" aria-hidden="true">
        {itemCount}
      </span>
    </button>
  );
};

export default UserTools;
